const doc = [({"en":({"adminConstantHotelCheckInRequiredGuestInfoScope":({"allGuests":"All guests", "onlyRepresentative":"Only representative"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;